import React from "react";
import { Calendar } from "lucide-react";
import { fmtDashboardOccurrence } from "../../lib/dashboardFormat";

/**
 * Compact week picker for recurring events — one selected date, rest in a native select.
 */
export default function OccurrenceSelector({ occurrences = [], selected, onChange }) {
  if (!occurrences.length || occurrences.length < 2) return null;

  const value = selected || (occurrences[0] ? occurrences[0].slice(0, 10) : "");

  return (
    <div className="max-w-page mx-auto px-4 mt-4" data-testid="occurrence-selector">
      <label className="flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-3">
        <span className="inline-flex items-center gap-1.5 font-ui font-medium text-[13px] text-ink/70 shrink-0">
          <Calendar className="w-4 h-4" strokeWidth={2.5} aria-hidden />
          This week
        </span>
        <select
          className="field w-full sm:max-w-xs font-ui font-medium text-[14px] min-h-[44px] cursor-pointer"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Select occurrence date"
          data-testid="occurrence-select"
        >
          {occurrences.map((iso) => {
            const key = iso.slice(0, 10);
            return (
              <option key={key} value={key} data-testid={`occurrence-${key}-btn`}>
                {fmtDashboardOccurrence(iso)}
              </option>
            );
          })}
        </select>
      </label>
    </div>
  );
}
